import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

/** Rejects values consisting only of whitespace. Empty values are left to Validators.required. */
export const notBlankValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (typeof value === 'string' && value.length > 0 && value.trim().length === 0) {
    return {blank: true};
  }
  return null;
};

/** German zip codes must have exactly 5 digits; other countries keep the generic 4–10 digit rule. */
export function zipCodeValidator(countryControlName = 'country'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value == null || value === '') {
      return null;
    }
    const zip = String(value).trim();
    const country = control.parent?.get(countryControlName)?.value;
    const pattern = country === 'DEU' ? /^\d{5}$/ : /^\d{4,10}$/;
    return pattern.test(zip) ? null : {zipCode: true};
  };
}
